import { axiosAPI } from './axiosAPI';

import { checkIsGlobalTechAdminPath } from './helpers/checkIsGlobalTechAdmin';

const interceptorState = {
    requestCancellationInterceptor: null,
};

export const setupRequestCancellationInterceptor = (getControllers) => {
    // Remove existing interceptor if it exists
    if (interceptorState.requestCancellationInterceptor !== null) {
        axiosAPI.interceptors.request.eject(interceptorState.requestCancellationInterceptor);
    }

    interceptorState.requestCancellationInterceptor = axiosAPI.interceptors.request.use(
        (config) => {
            const controller = getControllers().getCurrentController();

            // Check if the path is global or tech admin
            if (checkIsGlobalTechAdminPath(config.url) && controller) {
                config.signal = controller.signal;
            }

            return config;
        }
    );
};
